export const fieldsWithHelpAutoExpanded = ["RoofResealed"];
